import { insuranceImportService } from "./service";
import { InsuranceImport } from "./types";

export const createInsuranceImport = async (insuranceImportId: string) => {
  const { data } = await insuranceImportService.post<InsuranceImport>(``);

  return data;
};
